import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { EmptyState } from '../shared/components/EmptyState';

export function RequireAdmin(): React.ReactElement {
  const { adminAccess } = useAuth();

  if (adminAccess === 'checking') {
    return <EmptyState title="Checking access…" description="Verifying your admin permissions." />;
  }

  if (adminAccess === 'denied') {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
